import { useQuery, UseQueryOptions, UseQueryResult } from "@tanstack/react-query";
import { enum_api_uri } from "../utils/enum";
import axiosInstance from "./axiosInstanse";

export interface MypageResponseData {
    c_code: string;
    c_company_number: string;
    c_company: string;
    c_phone: string;
    c_month_yn: string;
    c_no_yn: string;
    c_addr_defalt: string;
    c_addr: string;
    c_addr_value: string;
    C_Post: string;
    C_ADDR_Tel: string;
    C_ADDR1: string;
    C_ADDR2: string;
    C_Branch: string;
    dname: string;
    dtel: string;
    c_raddr: string;
    c_raddr_value: string;
    C_RPost: string;
    C_RADDR_Tel: string;
    C_RADDR1: string;
    C_RADDR2: string;
    C_RBranch: string;
    dname1: string;
    dtel1: string;
    c_seaddr: string;
    c_seaddr_value: string;
    C_SePost: string;
    C_SeADDR_Tel: string;
    C_SeADDR1: string;
    C_SeADDR2: string;
    C_SeBranch: string;
    dname2: string;
    dtel2: string;

    dcode: string;
    dcode1: string;
    dcode2: string;
}

export const useGetMypageInfo = (
    options?: Partial<UseQueryOptions<MypageResponseData, Error>>,
): UseQueryResult<MypageResponseData, Error> => {
    return useQuery({
        queryKey: ["useGetMypageInfo"],
        queryFn: async () => {
            const response = await axiosInstance.get(enum_api_uri.info);
            return response.data.data;
        },
        ...options,
    });
};
